/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Zns_Param_UnmappedInputs */

const vi_error_zns_param_unmapped = /** @type {(inputs: Error_Zns_Param_UnmappedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tham số bắt buộc — chọn nguồn dữ liệu hoặc nhập giá trị cố định.`)
};

/**

* @param {Error_Zns_Param_UnmappedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zns_param_unmapped = /** @type {((inputs?: Error_Zns_Param_UnmappedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zns_Param_UnmappedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zns_param_unmapped(inputs)
});